import { useState } from 'react';
import { Link } from 'react-router-dom';
import { packages } from '@/mocks/photography';

export default function PricingSection() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            写真套餐
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            透明定价，品质保证，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {packages.map((pkg, index) => (
            <div
              key={pkg.name}
              className={`relative rounded-xl border-2 p-6 md:p-7 transition-all duration-300 cursor-pointer ${
                pkg.popular
                  ? 'border-primary-500 bg-primary-50/30'
                  : 'border-background-200/70 bg-background-50 hover:border-primary-300'
              }`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {pkg.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                  热门推荐
                </div>
              )}
              <h3 className="text-lg font-heading text-foreground-950 mb-2">{pkg.name}</h3>
              <div className="mb-5">
                <span className="text-3xl font-heading text-foreground-950">&yen;{pkg.price}</span>
                <span className="text-foreground-500 text-sm ml-1">/套</span>
              </div>
              <ul className="space-y-2.5 mb-6">
                {pkg.features.map((feat, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-foreground-600">
                    <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                    <span>{feat}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                className={`block text-center py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  pkg.popular
                    ? 'bg-primary-500 text-white hover:bg-primary-600'
                    : 'border border-foreground-300 text-foreground-700 hover:border-primary-500 hover:text-primary-500'
                }`}
              >
                {hoveredIndex === index ? '立即预约' : '了解详情'}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}